import { memo, forwardRef, useEffect, useState, useRef } from 'react';
import { BzModal, BzModalBody, BzModalHeader, BzTabs, BzTab, BzTabsContainer, BzInputText } from '../../../components';
import { handleModal } from '../../../redux/actions/modals';
import { useSelector, useDispatch } from 'react-redux';
import Broker from './Broker';
import Order from './Order';
import ExchangeNotificationMessages from './ExchangeNotificationMessages';
import { Row, Col, Dropdown, Container } from 'react-bootstrap';
import { DEFAULT_PAGE_SIZE, EXCHANGE_NAME_API, EXCHANGE_NAME_NOTIFICATION, MESSAGE_HUB_CHIPS } from '../../../utils/global_variables';
import { clearNseState, getMessagesBroker, getMessagesNse, getMessagesOrders, updateNotificationsCountStatus } from '../../../redux/actions/messages';
import useInfiniteScroll from '../../../hooks/useInfiniteScroll';


const NotificationModal = ({ brokerPageNo, ordersPageNo, NsePageNo, setBrokerPageNo, setOrdersPageNo, setNsePageNo, handleNotification, notificationExchange, arrExchangeType, notificationActiveChip, isExpanded, setIsExpanded }) => { //  Hari K :06-11-2023: BT-109371 message hub -receiving props

    const dispatch = useDispatch();
    const { modals } = useSelector(state => state.modals);
    const { arrOrders, arrNse, isReachedLimit, arrBroker } = useSelector(state => state.messages); //  Hari K :06-11-2023: BT-109371 message hub -receving isReachedLimit
    const [searchText, setSeachText] = useState(''); // Hari K:06-11-2023 search state

    const MessagesClose = () => {
        dispatch(handleModal([{ "MESSAGES": false }]));
        setIsExpanded(!isExpanded);
        // Hari k :02-11-2023, SAT-109371 message hub- making states empty-start
        setSeachText('');
        dispatch(updateNotificationsCountStatus());
        // Hari k :02-11-2023, SAT-109371 message hub-making state empty-end

    };

    const [dataInExpandOrder, setdataInExpandOrder] = useState([]);
    const [dataInExpandBroker, setdataInExpandBroker] = useState([]);




    const CustomDropdownToggle = forwardRef(({ children, onClick, className }, ref) => (
        <div
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}
        </div>
    ));

    // Hari k :02-11-2023, SAT-109371 message hub-search and chip change functionalty-start
    const onSearchChange = (value) => {
        setSeachText(value);
    };

    const handleChipChange = (name, value) => {
        setSeachText('');
        handleNotification(name, value);

    };
    // Hari k :02-11-2023, SAT-109371 message hub-search and chip change functionalty-end



    // Hari k :02-11-2023, SAT-109371 message hub infinity scrolling functionality -start

    const targetDiv = useRef(null);
    const onScroll = () => {
        handleScroll();
    };

    const [isNearBottom, handleScroll] = useInfiniteScroll(targetDiv, 190);

    useEffect(() => {
        if (isNearBottom) {
            // Ameersha N :15-11-2023 SAT-109371 message hub - issue - index increasing after scroll end - Start
            if (notificationActiveChip === MESSAGE_HUB_CHIPS.ORDERS && isReachedLimit === false) {
                dispatch(getMessagesOrders({ pageNo: ordersPageNo }));
                setOrdersPageNo(prev => prev + 1);
            }
            else if (notificationActiveChip === MESSAGE_HUB_CHIPS.BROKER && isReachedLimit === false) {
                dispatch(getMessagesBroker({ pageNo: brokerPageNo }));
                setBrokerPageNo(prev => prev + 1);

            }
            else if (notificationActiveChip === MESSAGE_HUB_CHIPS.EXCHANGES && isReachedLimit === false) {

                dispatch(getMessagesNse(EXCHANGE_NAME_API.NSE_EQ_API, {
                    noofhrs: 1,
                    pageNo: NsePageNo,
                    pageSize: DEFAULT_PAGE_SIZE.EXCHANGE_MESSAGES_PAGE_SIZE
                }));
                setNsePageNo(prev => prev + 1);
            }
            // Ameersha N :15-11-2023 SAT-109371 message hub - issue - index increasing after scroll end - End
        }
    }, [isNearBottom]);
    // Hari k :02-11-2023, SAT-109371 message hub infinity scrolling functionality -start


    // Hari k :02-11-2023, BT-109371 message hub - on changing of exchange drop down function-start

    const handleEchangeDropDown = (name, value) => {
        setNsePageNo(2);
        dispatch(clearNseState());
        dispatch(getMessagesNse(value, {
            noofhrs: 1,
            pageNo: 1,
            pageSize: DEFAULT_PAGE_SIZE.EXCHANGE_MESSAGES_PAGE_SIZE
        }));
        handleNotification(name, value);
    };
    // Hari k :02-11-2023, BT-109371 message hub - on changing of exchange drop down function -start

    return (
        <BzModal size="lg" show={modals['MESSAGES']} onHide={MessagesClose} centered>
            <BzModalHeader className='modaltabs-header'>
                <Container fluid className='p-0'>
                    <Row className='g-0'>
                        <Col md={11} className='d-flex justify-content-start align-self-center'>
                            <div className='font-medium font-size4 color-text'>Notifications</div>
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div className='icon-16 icon-close icon-dark' onClick={MessagesClose}></div>
                        </Col>
                    </Row>
                </Container>
            </BzModalHeader>
            <BzModalBody className='px-0 messages-modal-body'>
                <div className='messages-uncroll'>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col className='bdr-btm messages-modal'>
                                <BzTabs className='nav nav-tabs horizontal-scroll-wrap d-flex flex-row'>
                                    <BzTab className='nav-link text-capitalize' isActive={notificationActiveChip == 'broker'} tabKey='broker' onClick={() => handleChipChange('broker')}>Broker</BzTab>
                                    <BzTab className='nav-link text-capitalize' isActive={notificationActiveChip == 'order'} tabKey='order' onClick={() => handleChipChange('order')}>Order</BzTab>
                                    <BzTab className='nav-link text-capitalize d-flex align-items-center' isActive={notificationActiveChip == 'exchange'} tabKey='exchange'>
                                        <div onClick={() => handleChipChange('exchange', notificationExchange)} >{EXCHANGE_NAME_NOTIFICATION[notificationExchange] ? EXCHANGE_NAME_NOTIFICATION[notificationExchange] : notificationExchange?.replace('_', ' ')}</div>
                                        <div>
                                            <Dropdown>
                                                <Dropdown.Toggle>
                                                    <div className='icon-12 icon-arrowdown icon-dark ms-2'></div>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    {arrExchangeType?.map((each, index) => (
                                                        <Dropdown.Item key={index} onClick={() => handleEchangeDropDown('exchange', each)}>
                                                            <div>{(EXCHANGE_NAME_NOTIFICATION[each]) ? EXCHANGE_NAME_NOTIFICATION[each] : each.replace('_', ' ')}</div>
                                                        </Dropdown.Item>
                                                    ))}
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </div>
                                    </BzTab>
                                </BzTabs>
                            </Col>
                        </Row>
                        <Row className='g-0 my-2 justify-content-end me-3'>
                            <Col md={4}>
                                <div className='position-relative w-100'>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText value={searchText} onChange={(e) => onSearchChange(e.target.value)} size='sm' placeholder='Search...' type="search" className='p-l-30 font-regular'></BzInputText>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className='messages-scroll' ref={targetDiv} onScroll={onScroll}>
                    <Container fluid className='p-0'>
                        <Row className='g-0'>
                            <Col>
                                <BzTabsContainer>
                                    {notificationActiveChip === MESSAGE_HUB_CHIPS.BROKER && <Broker arrBroker={dataInExpandBroker?.length ? dataInExpandBroker : arrBroker} searchText={searchText} />}
                                    {notificationActiveChip === MESSAGE_HUB_CHIPS.ORDERS && <Order arrOrders={dataInExpandOrder?.length ? dataInExpandOrder : arrOrders} searchText={searchText} />}
                                    {notificationActiveChip === MESSAGE_HUB_CHIPS.EXCHANGES && <ExchangeNotificationMessages arrNse={arrNse} notificationExchange={notificationExchange} searchText={searchText} />}
                                </BzTabsContainer>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </BzModalBody>
        </BzModal>
    );
};

export default memo(NotificationModal);